// API URLs by environment
// NODE_ENV is injected by webpack DefinePlugin at build time
const API_URLS = {
    // Local development
    development: 'http://localhost:3000',
    // Deployed environments
    e2e: 'https://backend.hof2026-e2e.a.intuit.com',
    qal: 'https://backend.hof2026-qal.a.intuit.com',
    prd: 'https://backend.hof2026.a.intuit.com',
};
/**
 * Get the API URL for the current environment
 * process.env.NODE_ENV is replaced at build time by webpack DefinePlugin
 * @returns {string} The API base URL
 */
export const getApiUrl = () => {
    // NODE_ENV is injected by webpack DefinePlugin (literal replacement)
    const env = process.env.NODE_ENV || 'development';
    return API_URLS[env] || API_URLS.development;
};
export const getAssetManagerUrl = () => {
    return 'https://prdasset.intuit4education.a.intuit.com/hof/events';
};
export const getEventName = () => {
    return 'hof-spring-2026';
};
export const getPreSurveyUrl = () => {
    return `${getAssetManagerUrl()}/${getEventName()}/pre-survey/latest/pre-survey.json`;
};
export const getPostSurveyUrl = () => {
    return `${getAssetManagerUrl()}/${getEventName()}/post-survey/latest/post-survey.json`;
};
export const getActivitiesUrl = () => {
    return `${getAssetManagerUrl()}/${getEventName()}/student-activities/latest/student-activities.json`;
};
